import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
let routes = [
    {
        path: '/',
        name: 'index',
        meta: { tx: 1 },
        redirect: '/Home'
    },
    {
        path: '/home',
        name: 'Home',
        meta: { tx: 1 },
        component: () =>
            import('@/views/home')
    },
    {
        path: '/welcome',
        name: 'Welcome',
        meta: { tx: 1 },
        component: () =>
            import('@/views/welcome')
    },
    {
        path: '/login',
        name: 'Login',
        meta: { tx: 1 },
        component: () =>
            import('@/views/login')
    },
    {
        path: '/detail',
        name: 'Detail',
        meta: { tx: 1 },
        component: () =>
            import('@/views/detail')
    },
    {
        path: '/register',
        name: 'Register',
        meta: { tx: 2 },
        component: () =>
            import('@/views/register')
    },
    {
        path: '/recharge',
        name: 'Recharge',
        meta: { tx: 3 },
        component: () =>
            import('@/views/recharge')
    },
    {
        path: '/rechargeCurrency',
        name: 'RechargeCurrency',
        meta: { tx: 3 },
        component: () =>
            import('@/views/recharge/currency')
    },
    {
        path: '/with',
        name: 'With',
        meta: { tx: 3 },
        component: () =>
            import('@/views/with')
    },
    {
        path: '/withCurrency',
        name: 'WithCurrency',
        meta: { tx: 3 },
        component: () =>
            import('@/views/with/currency')
    },
    {
        path: '/market',
        name: 'Market',
        component: () =>
            import('@/views/market')
    },
    {
        path: '/mySelect',
        name: 'MySelect',
        meta: { tx: 3 },
        component: () =>
            import('@/views/market/mySelect')
    },
    {
        path: '/user',
        name: 'User',
        meta: { tx: 3 },
        component: () =>
            import('@/views/user')
    },
    {
        path: '/head',
        name: 'Head',
        meta: { tx: 3 },
        component: () =>
            import('@/views/user/head')
    },
    {
        path: '/common',
        name: 'Common',
        meta: { tx: 3 },
        component: () =>
            import('@/views/common')
    },
    {
        path: '/heel',
        name: 'Heel',
        meta: { tx: 3 },
        component: () =>
            import('@/views/heel')
    },
    {
        path: '/asset',
        name: 'Asset',
        meta: { keepAlive: true },
        component: () =>
            import('@/views/asset')
    },
    {
        path: '/assetTransfer',
        name: 'AssetTransfer',
        meta: { tx: 3 },
        component: () =>
            import('@/views/asset/transfer')
    },
    {
        path: '/assetFlashcash',
        name: 'AssetFlashcash',
        meta: { tx: 3 },
        component: () =>
            import('@/views/asset/flashcash')
    },
    {
        path: '/trade',
        name: 'Trade',
        meta: { tx: 3 },
        component: () =>
            import('@/views/trade')
    },
    {
        path: '/kline',
        name: 'Kline',
        meta: { tx: 3 },
        component: () =>
            import('@/views/trade/kline')
    },
    {
        path: '/iframePage',
        name: 'IframePage',
        meta: { tx: 1 },
        component: () =>
            import('@/views/iframePage')
    },
    {
        path: '/share',
        name: 'Share',
        meta: { tx: 3 },
        component: () =>
            import('@/views/share')
    },
    {
        path: '/invite',
        name: 'Invite',
        meta: { tx: 3 },
        component: () =>
            import('@/views/share/invite')
    },
    {
        path: '/inviteList',
        name: 'InviteList',
        meta: { tx: 3 },
        component: () =>
            import('@/views/share/inviteList')
    },
    {
        path: '/rollOut',
        name: 'RollOut',
        meta: { tx: 3 },
        component: () =>
            import('@/views/share/rollOut')
    },
    {
        path: '/rollOutList',
        name: 'RollOutList',
        meta: { tx: 3 },
        component: () =>
            import('@/views/share/rollOutList')
    },
    {
        path: '/commissionList',
        name: 'CommissionList',
        meta: { tx: 3 },
        component: () =>
            import('@/views/share/commissionList')
    },
    {
        path: '/property',
        name: 'Property',
        meta: { tx: 3 },
        component: () =>
            import('@/views/property')
    },
    {
        path: '/propertyList',
        name: 'PropertyList',
        meta: { tx: 3 },
        component: () =>
            import('@/views/property/propertyList')
    },
    {
        path: '/auth',
        name: 'Auth',
        meta: { tx: 3 },
        component: () =>
            import('@/views/auth')
    },
    {
        path: '/highAuth',
        name: 'HighAuth',
        meta: { tx: 3 },
        component: () =>
            import('@/views/auth/highAuth')
    },
    {
        path: '/assetAuth',
        name: 'AssetAuth',
        meta: { tx: 3 },
        component: () =>
            import('@/views/auth/assetAuth')
    },
    {
        path: '/bill',
        name: 'Bill',
        meta: { tx: 3 },
        component: () =>
            import('@/views/bill')
    },
    {
        path: '/safe',
        name: 'Safe',
        meta: { tx: 3 },
        component: () =>
            import('@/views/safe')
    },
    {
        path: '/upLoginPwd',
        name: 'UpLoginPwd',
        meta: { tx: 3 },
        component: () =>
            import('@/views/safe/upLoginPwd')
    },
    {
        path: '/upPayPwd',
        name: 'UpPayPwd',
        meta: { tx: 3 },
        component: () =>
            import('@/views/safe/upPayPwd')
    },
    {
        path: '/bindEmail',
        name: 'BindEmail',
        meta: { tx: 3 },
        component: () =>
            import('@/views/safe/bindEmail')
    },
    {
        path: '/bindPhone',
        name: 'BindPhone',
        meta: { tx: 3 },
        component: () =>
            import('@/views/safe/bindPhone')
    },
    {
        path: '/walletAddress',
        name: 'WalletAddress',
        meta: { tx: 3 },
        component: () =>
            import('@/views/safe/walletAddress')
    },
    {
        path: '/addWalletAddress',
        name: 'AddWalletAddress',
        meta: { tx: 3 },
        component: () =>
            import('@/views/safe/addWalletAddress')
    },
    {
        path: '/about',
        name: 'About',
        meta: { tx: 2 },
        component: () =>
            import('@/views/about')
    },
    {
        path: '/forgotPassword',
        name: 'ForgotPassword',
        meta: { tx: 2 },
        component: () =>
            import('@/views/forgotPassword')
    },
    {
        path: '/lang',
        name: 'Lang',
        meta: { tx: 3 },
        component: () =>
            import('@/views/lang')
    },
    {
        path: '/position',
        name: 'Position',
        meta: { tx: 3 },
        component: () =>
            import('@/views/position')
    },
    {
        path: '/positionInfo',
        name: 'PositionInfo',
        meta: { tx: 3 },
        component: () =>
            import('@/views/position/info')
    },
    {
        path: '/positionSecondInfo',
        name: 'PositionSecondInfo',
        meta: { tx: 3 },
        component: () =>
            import('@/views/position/secondInfo')
    },
    {
        path: '/notice',
        name: 'Notice',
        meta: { tx: 3 },
        component: () =>
            import('@/views/notice')
    },
    {
        path: '/help',
        name: 'Help',
        meta: { tx: 3 },
        component: () =>
            import('@/views/help')
    },
    {
        path: '/finance',
        name: 'Finance',
        meta: { tx: 3 },
        component: () =>
            import('@/views/finance')
    },
    {
        path: '/financeSim',
        name: 'FinanceSim',
        meta: { tx: 3 },
        component: () =>
            import('@/views/finance/sim')
    },
    {
        path: '/financeInfo',
        name: 'FinanceInfo',
        meta: { tx: 3 },
        component: () =>
            import('@/views/finance/info')
    },
    {
        path: '/financeList',
        name: 'FinanceList',
        meta: { tx: 3 },
        component: () =>
            import('@/views/finance/list')
    },
    {
        path: '/financeOrderInfo',
        name: 'FinanceOrderInfo',
        meta: { tx: 3 },
        component: () =>
            import('@/views/finance/orderInfo')
    },
    {
        path: '/c2c',
        name: 'C2c',
        meta: { tx: 3 },
        component: () =>
            import('@/views/c2c')
    },
    {
        path: '/c2cBuy',
        name: 'C2cBuy',
        meta: { tx: 3 },
        component: () =>
            import('@/views/c2c/buy')
    },
    {
        path: '/c2cSell',
        name: 'C2cSell',
        meta: { tx: 3 },
        component: () =>
            import('@/views/c2c/sell')
    },
    {
        path: '/c2cOrder',
        name: 'C2cOrder',
        meta: { tx: 3 },
        component: () =>
            import('@/views/c2c/order')
    },
    {
        path: '/chat',
        name: 'Chat',
        meta: { tx: 3 },
        component: () =>
            import('@/views/chat')
    },
    {
        path: '/chatList',
        name: 'ChatList',
        meta: { tx: 3 },
        component: () =>
            import('@/views/chat/list')
    },
    {
        path: '/down',
        name: 'Down',
        meta: { tx: 3 },
        component: () =>
            import('@/views/down')
    },
    {
        path: '/activity',
        name: 'Activity',
        meta: { tx: 3 },
        component: () =>
            import('@/views/activity')
    },
    {
        path: '/inviteReward',
        name: 'InviteReward',
        meta: { tx: 3 },
        component: () =>
            import('@/views/activity/inviteReward')
    },
    {
        path: '/rechargeReward',
        name: 'RechargeReward',
        meta: { tx: 3 },
        component: () =>
            import('@/views/activity/rechargeReward')
    },
    {
        path: '/authReward',
        name: 'AuthReward',
        meta: { tx: 3 },
        component: () =>
            import('@/views/activity/authReward')
    },
    {
        path: '/loan',
        name: 'Loan',
        meta: { tx: 3 },
        component: () =>
            import('@/views/loan')
    },
    {
        path: '/loanList',
        name: 'LoanList',
        meta: { tx: 3 },
        component: () =>
            import('@/views/loan/list')
    },
    { path: '*', redirect: '/404' }
]

const router = new VueRouter({ routes: routes })
export let routeStack = []
router.afterEach((to, from) => {
    // 有来源页面才记录，避免首次打开就入栈
    if (from && from.fullPath) {
        routeStack.push(from.fullPath)
        if (routeStack.length > 5) {
            routeStack.shift()
        }
    }
    localStorage.setItem('fullPath', to.fullPath)
    window.scrollTo(0, 0)
})
export default router